<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="m10.267 10.667-.934-.934L11.067 8 9.333 6.267l.934-.934L12 7.067l1.733-1.734.934.934L12.933 8l1.734 1.733-.934.934L12 8.933l-1.733 1.734ZM2 10V6h2.667L8 2.667v10.666L4.667 10H2Zm4.667-4.1L5.233 7.333h-1.9v1.334h1.9L6.667 10.1V5.9Z"
        />
    </svg>
</template>

<script setup lang="ts">
type NoSoundIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<NoSoundIconProps>();
</script>
